import React, { memo, useCallback, useState, useRef, useEffect } from "react"
import { Box, MenuItem, Checkbox, ListItemText } from "@mui/material";
import { ReactComponent as DropDownIcon2 } from "../../../assets/icons/icon-angle-down-2.svg";


const CustomMultiSelect = ({label, options, handleSelectedValue, optionsLabels, value, isComponentReady = true}) => {
    const [isDropDownOpen, setIsDropDownOpen] = useState(false)
    const [selectedValues, setSelectedValues] = useState(value ?? []);
    const selectRef = useRef(null);
    const [selectDropDownPos, setSelectDropDownPos] = useState('bottom-start');
    const pageWrapperEl = document.querySelector('.layout-wrapper');
    const selectDropdownRef = useRef(null);

    const handleCustomDropdown = useCallback((event) => {
        setIsDropDownOpen(isDropDownOpen ? false : true);
    })

    const handleSelectedOption = useCallback((val) => {
        let selected_values = Object.assign([], selectedValues);
        if(!(selected_values.indexOf(val) > -1) ) selected_values.push(val);
        setSelectedValues(selected_values);
        handleSelectedValue(selected_values);
        //setIsDropDownOpen(false);
    });

    useEffect(() => {
        if(isComponentReady && selectRef?.current && isDropDownOpen) {
            let selectDropDownEl = selectRef?.current?.querySelector('.re-form-select-custom-dropdown');
            //console.log((selectRef?.current?.offsetTop + 40 + selectDropDownEl?.offsetHeight), pageWrapperEl?.clientHeight, window.innerHeight);
            if((selectRef?.current?.offsetTop + 40 + selectDropDownEl?.offsetHeight) > pageWrapperEl?.clientHeight) {
                setSelectDropDownPos('top-start');
                selectDropDownEl.style.top = '-' + (selectDropDownEl?.offsetHeight + 2) + 'px';
            } else {
                setSelectDropDownPos('bottom-start');
            }
        }
    }, [selectRef.current, isComponentReady, selectDropdownRef.current, isDropDownOpen, pageWrapperEl?.clientHeight]);

    return (
        <Box className={`re-form-select-custom re-form-multiple-select-custom` + (isDropDownOpen ? ` open ` : ` `) + (selectedValues.length ? ` has-value ` : ` `)
            + ` ` + (selectDropDownPos)}
            ref={selectRef} >
            <Box className='re-form-select-custom-container' onClick={handleCustomDropdown} >
                <Box className='re-form-select-custom-label'>{selectedValues?.length ? selectedValues.join(', ') : label}</Box>
                <DropDownIcon2 />
            </Box>
            <Box className='re-form-select-custom-dropdown' ref={selectDropdownRef}>
                <ul className="re-form-select-custom-dropdown-options">
                    {
                        options?.map((item, i) => {
                            return <MenuItem className="re-form-select-custom-dropdown-option" onClick={() => handleSelectedOption(item[optionsLabels.value])}  
                                key={`${i}-concat-${item[optionsLabels.value]}`}  value={item[optionsLabels.value]} >
                                    <Checkbox data-flag={selectedValues.indexOf(item[optionsLabels.value]) > -1} checked={selectedValues.indexOf(item[optionsLabels.value]) > -1}
                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 20 } }} />
                                    <ListItemText primary={item[optionsLabels.label]} />
                            </MenuItem>
                        })
                    }
                </ul>
            </Box>
        </Box>
    )
}

export default memo(CustomMultiSelect)